export enum LoginTypeEnum {
    loginAndPassword = 1,
    google = 2,
    microsoft = 3,
}